import { useState, useEffect } from "react";

const DB_NAME = "ChronosDB";
const STORE_NAME = "config";
const CONFIG_ID = "main";

export function useLocalStorageDB() {
  const [pcId, setPcId] = useState("");
  const [terminalId, setTerminalId] = useState("");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [presencia, setPresencia] = useState("");
  const [planta, setPlanta] = useState("");
  const [visor, setVisor] = useState("");

  // --- Inicializar IndexedDB ---
  const openDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: "id" });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = (e) => reject(e.target.error);
    });
  };

  // --- Cargar configuración ---
  const loadConfigFromStorage = async () => {
    try {
      const db = await openDB();
      return new Promise((resolve) => { // <-- resolve definido aquí
        const tx = db.transaction(STORE_NAME, "readonly");
        const store = tx.objectStore(STORE_NAME);
        const req = store.get(CONFIG_ID);

        req.onsuccess = () => {
          const config = req.result || {};
             // Si no hay pcID, generar uno nuevo
        const id = config.pcID || crypto.randomUUID();

          setPcId(id);
          setTerminalId(config.terminalId || "");
          setUserId(config.userId || "");
          setPassword(config.password || "");
          setPresencia(config.presencia || "");
          setPlanta(config.planta || "");
          setVisor(config.visor|| "");
          resolve(config); // <-- ahora sí está definido
        };

        req.onerror = () => resolve({});
      });
    } catch (error) {
      console.error("Error cargando IndexedDB:", error);
      return {};
    }
  };

  // --- Guardar configuración ---
  const saveConfigToStorage = async (config) => {
    try {
      const db = await openDB();
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);
      store.put({ id: CONFIG_ID, ...config });
     // tx.oncomplete = () => console.log("Configuración guardada:");
      tx.onerror = (e) => console.error("Error guardando config:", e.target.error);
    } catch (error) {
      console.error("Error en IndexedDB:", error);
    }
  };

  // --- Limpiar configuración ---
  const clearConfigFromStorage = async () => {
    try {
      const db = await openDB();
      const tx = db.transaction(STORE_NAME, "readwrite");
      const store = tx.objectStore(STORE_NAME);
      store.delete(CONFIG_ID);
      tx.oncomplete = () => console.log("Configuración eliminada");
      tx.onerror = (e) => console.error("Error eliminando config:", e.target.error);

      setTerminalId("");
      setUserId("");
      setPassword("");
      setPresencia("");
      setPlanta("");
      setVisor("");
    } catch (error) {
      console.error("Error limpiando IndexedDB:", error);
    }
  };

  // --- Guardar datos actuales ---
  const handleSubmitConfig = () => {
    const configData = {
      pcId,
      terminalId,
      userId,
      password,
      presencia,
      planta,
      visor,
      lastUpdated: new Date().toISOString(),
    };
    saveConfigToStorage(configData);
    
    return configData;
  };

  // --- Activar persistencia para localhost ---
 /* useEffect(() => {
    if (window.location.hostname === "localhost") {
      if (navigator.storage && navigator.storage.persist) {
        navigator.storage.persist().then((persisted) => {
          console.log(
            persisted
              ? "IndexedDB persistente activada para localhost"
              : "No se pudo activar persistencia"
          );
        });
      }
    }
  }, []);*/

  return {
    pcId,
    terminalId,
    setTerminalId,
    userId,
    setUserId,
    password,
    setPassword,
    presencia,
    setPresencia,
    planta,
    setPlanta,
    visor,
    setVisor,
    loadConfigFromStorage, // Devuelve la config
    clearConfigFromStorage,
    handleSubmitConfig
  };
}
